import { useState, useMemo } from "react";

import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import DataTable from "cxfcomponents/Tables/DataTable";
import EditorInput from "../../../EditorInput";
import { stringifyWithSpaces } from "helpers/common";

const QueryOutput = ({ data }) => {
  const [tabValue, setTabValue] = useState(1);
  let tableHeaders = data?.body?.result?.length ? Object.keys(data?.body?.result[0]) : [];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const dataTableData = useMemo(() => {
    if (data?.statusCode === 200 && data?.body?.query?.includes("SELECT")) {
      return {
        columns: tableHeaders.map((header) => {
          return {
            Header: header?.toUpperCase(),
            accessor: header,
          };
        }),
        rows: data?.body?.result || [],
      };
    }
  }, [data]);

  const renderTabs = () => {
    if (data?.statusCode === 200 && data?.body?.query?.includes("SELECT")) {
      return (
        <>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab value={1} label="Json" sx={{ fontSize: "12px" }} />
            <Tab value={2} label="Table" sx={{ fontSize: "12px" }} />
          </Tabs>
          {tabValue === 1 && (
            <EditorInput
              fieldValue={stringifyWithSpaces(data?.body?.result)}
              language="json"
              height="400px"
              options={{ readOnly: true, automaticLayout: true }}
            />
          )}
          {tabValue === 2 && (
            <DataTable table={dataTableData} showTotalEntries={false} entriesPerPage={false} />
          )}
        </>
      );
    }
  };

  if (data?.statusCode === 500) {
    return (
      <Paper className="custom-light-theme" sx={{ p: 2, display: "flex", alignItems: "center", gap: 1, backgroundColor: "#ededed" }}>
        {data?.body && data?.body?.message && (
          <>
            <HighlightOffIcon color="error" />
            <SoftTypography variant="caption" color="error">
              {data?.body?.message}
            </SoftTypography>
          </>
        )}
      </Paper>
    );
  }

  return (
    <SoftBox display="flex" flexDirection="column" gap={2}>
      <Paper className="custom-light-theme" sx={{ p: 2, display: "flex", alignItems: "center", gap: 1, backgroundColor: "#ededed" }}>
        {data?.statusCode === 200 && (
          <>
            <CheckCircleOutlineIcon color="success" />
            <SoftTypography variant="caption" color="success">
              Complete
            </SoftTypography>
          </>
        )}
      </Paper>
      {renderTabs()}
    </SoftBox>
  );
};

export default QueryOutput;
